import React, { useEffect, useMemo, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { DateConvert } from "../../helper/DateConvert";
import { BaseUrl } from "../../helper/BaseUrl";

const truncateTitle = (title, charLimit = 60) => {
  const value = String(title || "").trim();
  return value.length > charLimit ? `${value.slice(0, charLimit)}...` : value;
};

export default function BlogListingSection({ allData = [] }) {

  const [searchTerm, setSearchTerm] = useState("");
  const [visibleCount, setVisibleCount] = useState(6);
  const [isLoadMore, setIsLoadMore] = useState(true);
  const [open, setOpen] = useState(false);
  const [selected, setSelected] = useState("All Categories");
  const filterRef = useRef(null);

  /* ----------------------------------
     CREATE UNIQUE CATEGORIES
  -----------------------------------*/
  const categories = useMemo(() => {
    const apiCategories = allData
      .map((item) => item?.category_name?.trim())
      .filter(Boolean);

    return ["All Categories", ...new Set(apiCategories)];
  }, [allData]);



  /* ----------------------------------
     FILTER LOGIC (FIXED)
  -----------------------------------*/
  const filteredData = useMemo(() => {
    return allData.filter((item) => {
      const title = item?.title?.toLowerCase().trim() || "";
      const category = item?.category_name?.toLowerCase().trim() || "";

      const matchSearch = title.includes(
        searchTerm.toLowerCase().trim()
      );

      const matchCategory =
        selected === "All Categories"
          ? true
          : category === selected.toLowerCase().trim();

      return matchSearch && matchCategory;
    });
  }, [allData, searchTerm, selected]);

  /* ----------------------------------
     LOAD MORE / VIEW LESS
  -----------------------------------*/
  useEffect(() => {
    setVisibleCount(6);
    setIsLoadMore(true);
  }, [searchTerm, selected]);

  const handleLoadMore = () => {
    if (isLoadMore) {
      const next = visibleCount + 3;

      setVisibleCount(next);

      if (next >= filteredData.length) {
        setIsLoadMore(false);
      }
    } else {
      setVisibleCount(6);
      setIsLoadMore(true);
    }
  };

  return (
    <section className="blog-listing-section">
      <div className="container">
        <div className="blog-filter-bar">
          <form className="blog-search" onSubmit={(e) => e.preventDefault()}>
            {/* <span className="visually-hidden">Search blogs</span> */}
            <input type="search" name="search" value={searchTerm} placeholder="Search Here..." onChange={(e) => setSearchTerm(e.target.value)} />
            <button type="submit" className="blog-search-icon" aria-hidden="true">
              <i className="fa-solid fa-magnifying-glass" />
            </button>
          </form>
          <label className="blog-category-filter">
            <span className="visually-hidden">  Filter by category </span>
            <select value={selected} onChange={(e) => setSelected(e.target.value)} >
              {categories.map((item) => (
                <option value={item} key={item}>
                  {item}
                </option>
              ))}
            </select>
          </label>
        </div>
        <div className="row blog-listing-cards" aria-live="polite" >
          {filteredData.slice(0, visibleCount).map((data, index) => (
            <div className="col-lg-4 col-md-6" key={index} >
              <article className="blog-listing-card">
                <img src={data?.thumbnail ? `${BaseUrl}${data.thumbnail}` : undefined} loading="lazy" className="img-responsive" alt={data?.alt_thumbnail} />
                <div className="blog-listing-card-content">
                  <p className="blog-listing-card-date">{DateConvert(data?.date)}</p>
                  <h2>{truncateTitle(data?.title)}</h2>
                  <p className="blog-listing-card-description">
                    {data?.brief?.slice(0, 100) + "..."}
                  </p>
                  <Link to={`${data?.slug}`}>
                    Read More
                    <i className="fa-solid fa-arrow-right" aria-hidden="true" />
                  </Link>
                </div>
              </article>
            </div>
          ))}
        </div>
        {filteredData.length > 6 && (
          <div className="blog-load-more text-center">
            <button type="button" className="default-btn" onClick={handleLoadMore}>
              {isLoadMore ? "View More" : "View Less"}
            </button>
          </div>
        )}
      </div>
    </section>
  );
}
